import React, { Component } from "react";
import BuyerEmpanelmentDocPage from "./BuyerEmpanelmentDocPage";
import history from "../../../history";

class BuyerUploadDocuments extends Component {
    render() {
        return (
            <div className="BodyInContainer">
                <div className="d-block clearfix">
                    <div className="Header-Content float-start">
                        <h3 className="pageMainTitle">Buyer Document Upload</h3>
                    </div>
                    <div className="float-end mt-15 ">
                        <button
                            className="float-end cardBackBtn"
                            onClick={() => {
                                history.goBack();
                            }}
                        >
                            Back
                        </button>
                    </div>
                </div>
                <div className="mainBodyCard pt-0">
                    <BuyerEmpanelmentDocPage manualOnly={true} />
                </div>
            </div>
        );
    }
}

export default BuyerUploadDocuments;